export default __webpack_public_path__ + "static/media/onboarding3.50af622d.png";